import axios from "axios"

export const coefAccIVA = (product) => {
  if (product['iva_Incluido'] == "V") {
    const realCost = parseFloat(product['valor_Producto']) / (1 + (parseFloat(product['tarifa_IVA']) / 100))
    const ivaTax = parseFloat(product['valor_Producto']) - (realCost)
    return {
      realCost,
      ivaTax
    }
  } else {
    const ivaTax = parseFloat(product['valor_Producto']) * parseFloat(product['tarifa_IVA']) / 100
    const realCost = parseFloat(product['valor_Producto'])
    return {
      realCost,
      ivaTax
    }
  }
}

export const coefConsTax = (product) => {
  switch (product['tipo_ImpConsumo']) {
    case "N":
      return 0
    case "V":
      return product['valor_ImpConsumo']
    case "P":
      return parseFloat(product['tarifa_ImpConsumo']) * parseFloat(product['valor_Producto'])
    default:
      return 0
  }
}

export const formatter = {
  format(value, digits = 2) {
    const formatter = new Intl.NumberFormat('es', { maximumFractionDigits: digits })
    return formatter.format(value)
  }
}

export const toBase64 = (file2base64) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    if (file2base64[0]) {
      reader.readAsDataURL(file2base64[0]);
      reader.onload = () => resolve(reader.result.replace(/^data:.+;base64,/, ''));
      reader.onerror = error => reject(error);
    } else {
      resolve("")
    }

  })
}

export const replace_ = (string) => {
  return string.replace(/_/g, ' ')
}

export const getCompanyLogo = async () => {
  try {
    const res = await axios.get('/source.json')
    return res.data
  } catch (error) {
    console.log(error)
    throw error
  }
}

export const getImg = async (context, path) => {
  try {
    const { source } = await getBackendUrl()
    const response = await fetch(
      `${source}${path}`,
      {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return response
  } catch (err) {
    console.log(err)
    throw err.response
  }

}

export const getBackendUrl = async () => {
  try {
    const { data } = await axios.get('/source.json')
    return data
  } catch (error) {
    console.log(error)
    throw error
  }
}

export const getVersion = async () => {
  try {
    const { data } = await axios.get('/version.json', { cache: false });

    return data;
  } catch (error) {
    console.log(error)
    throw error
  }
}

export const getRoutesModel = async () => {
  try {
    const { data } = await axios.get('/routes-model.json', { cache: false });

    return data;
  } catch (error) {
    console.log(error)
    throw error
  }
}

export const errorMessage = (errorObj) => {
  let message = 'No se pudo completar la acción'
  try {
    if (typeof (errorObj.data.errorMessage) === 'string') {
      return errorObj.data.errorMessage
    }
    const keys = Object.keys(errorObj.data.errorMessage)
    if (keys < 1) {
      return message
    }

    message = ""
    keys.forEach(key => {
      message += `${key}: ${errorObj.data.errorMessage[key][0]}\n`
    })
    return message
  } catch (error) {
    console.log(error)
    return message
  }
}

export const user_uid = () => {
  const wni = window.navigator
  const wsi = window.screen
  let uid = wni.mimeTypes.length

  uid += wni.userAgent.replace(/\D+/g, "")
  uid += wni.plugins.length
  uid += wsi.height || ""
  uid += wsi.width || ""
  uid += wsi.pixelDepth || ""
  
  return uid
}
